import React, {useContext} from "react";
import logo from "../../asset/melodico.png";
import "./profile.css";



function Profile() {  
    // const { userData,setUserData } = useContext(Users)
  
  return (
    <div>
      <h1>Profile</h1><br/>
      {/* <h4><b>User ID:</b>{userData.user.id}</h4><br/> */}
      {/* <h4><b>User Name:</b>{userData.user.name}</h4><br/> */}
      {/* <h4><b>User Email:</b>{userData.user.email}</h4><br/> */}
    </div>
  )
}


export default Profile;
